(() => {
  const root = document.querySelector('[data-ego-newsletter-popup]');
  if (!root) return;

  const dialog = root.querySelector('[role="dialog"]');
  const closes = [...root.querySelectorAll('[data-ego-newsletter-close]')];
  const form = root.closest('form');
  const storageKey = 'ego_newsletter_popup_v1';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const oneYear = 365 * 24 * 60 * 60 * 1000;
  const params = new URLSearchParams(window.location.search);
  const forcePreview = params.get('ego_newsletter') === 'preview';
  const submitted = root.dataset.formSuccess === 'true' || params.get('contact_posted') === 'true';
  const suppressedPath = /^(\/pages\/test(?:\/|$)|\/cart(?:\/|$)|\/products\/(?:order|feel|power|mind|the-collective)(?:\/|$))/.test(window.location.pathname);
  if (suppressedPath && !forcePreview && !submitted) return;
  let previousFocus = null;
  let opened = false;

  const readExpiry = () => {
    try { return Number(window.localStorage.getItem(storageKey) || 0); }
    catch (_) { return 0; }
  };

  const storeExpiry = (duration) => {
    try { window.localStorage.setItem(storageKey, String(Date.now() + duration)); }
    catch (_) {}
  };

  const canOpen = () => forcePreview || submitted || readExpiry() < Date.now();

  const focusable = () => [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')];

  const open = () => {
    if (opened || !canOpen()) return;
    opened = true;
    previousFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ego-newsletter-lock');
    window.requestAnimationFrame(() => {
      const target = submitted ? dialog.querySelector('a') : dialog.querySelector('input');
      (target || dialog).focus({ preventScroll: true });
    });
  };

  const close = (remember = true) => {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ego-newsletter-lock');
    if (remember && !forcePreview) storeExpiry(submitted ? oneYear : sevenDays);
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  };

  closes.forEach((button) => button.addEventListener('click', () => close(true)));

  document.addEventListener('keydown', (event) => {
    if (!opened) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }
    if (event.key !== 'Tab') return;
    const nodes = focusable();
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (form) form.addEventListener('submit', () => storeExpiry(oneYear));

  if (submitted || forcePreview) {
    window.setTimeout(open, 250);
    return;
  }

  if (!canOpen()) return;

  const timer = window.setTimeout(open, 8000);
  const onScroll = () => {
    const documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight;
    if (documentHeight > 0 && window.scrollY / documentHeight >= 0.45) {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      open();
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();
